

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        // constructor 里只做最基本的初始化，不访问 DOM
        this.form = null;
        this.cart = null;
        this.submitButton = null;
        this.submitButtonText = null;
        this.errorMessageWrapper = null;
        this.errorMessage = null;
        this.hideErrors = false;
        this.error = false;
      }

      connectedCallback() {
        // 当元素被插入 DOM 时执行，此时子元素都已可用
        this.form = this.querySelector('form');
        
        // 获取 variantIdInput 并设置 disabled = false
        const variantInput = this.querySelector('[name=id]');
        if (variantInput) {
          variantInput.disabled = false;
        }

        // 获取购物车元素
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        
        // 获取提交按钮相关元素
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
          
          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        }

        // 设置隐藏错误配置
        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // 绑定表单提交事件
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        // 初始化错误消息元素（如果有的话）
        if (!this.hideErrors) {
          this.errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
          if (this.errorMessageWrapper) {
            this.errorMessage = this.errorMessageWrapper.querySelector('.product-form__error-message');
          }
        }
      }

      disconnectedCallback() {
        // 清理事件监听，避免内存泄漏
        if (this.form) {
          this.form.removeEventListener('submit', this.onSubmitHandler.bind(this));
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        // 添加安全检查
        if (!this.submitButton) return;
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) {
                this.submitButtonText.classList.add('hidden');
              }
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (this.cart) {
                      this.cart.renderContents(response);
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.cart) {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              if (!this.error) {
                this.submitButton.removeAttribute('aria-disabled');
              }
            }
            
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) {
              spinner.classList.add('hidden');
            }
            
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        // 如果还没有获取错误消息元素，尝试获取
        if (!this.errorMessageWrapper) {
          this.errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
          if (this.errorMessageWrapper) {
            this.errorMessage = this.errorMessageWrapper.querySelector('.product-form__error-message');
          }
        }
        
        if (!this.errorMessageWrapper) return;
        
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) return;
        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }

      get variantIdInput() {
        return this.querySelector('[name=id]');
      }
    }
  );
}